"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectTaskOwnersContext = void 0;
exports.ProjectCaseListSheetButton = ProjectCaseListSheetButton;
const react_1 = __importStar(require("react"));
const CommonComponents_1 = require("../../View/Resultsets/CommonComponents");
const CaseListSheetModal_1 = require("./CaseListSheetModal");
exports.ProjectTaskOwnersContext = (0, react_1.createContext)({ owners: [] });
/**
 * Akcja projektu: „Spis spraw" dla WSZYSTKICH kontraktów projektu w jednym arkuszu.
 * Arkusz ląduje w podfolderze „Spisy spraw" w folderze projektu (spisy pojedynczych
 * kontraktów zostają w folderach kontraktów).
 */
function ProjectCaseListSheetButton({ dataObject, layout }) {
    const project = dataObject;
    const loaded = (0, react_1.useContext)(exports.ProjectTaskOwnersContext);
    const [show, setShow] = (0, react_1.useState)(false);
    if (!project.gdFolderId || !project.ourId)
        return null;
    const isLoadedProject = project.id === loaded.projectId;
    const taskOwners = isLoadedProject ? loaded.owners : [];
    return (
    // Klik w ikonę nie może dojść do wiersza — zaznaczenie projektu przeładowuje
    // drzewo kontraktów i zamknęłoby dopiero co otwarte okno. Dwuklik zatrzymujemy
    // z tego samego powodu: wiersz odpaliłby na nim nawigację do szczegółów.
    react_1.default.createElement("span", { onClick: (e) => e.stopPropagation(), onDoubleClick: (e) => e.stopPropagation() },
        react_1.default.createElement(CommonComponents_1.CaseListIconButton, { layout: layout, onClick: () => setShow(true) }),
        react_1.default.createElement(CaseListSheetModal_1.CaseListSheetModal, { show: show, onHide: () => setShow(false), scope: {
                action: "projectCaseListSheet",
                target: { projectOurId: project.ourId },
                subtitle: "Arkusz Google ze wszystkimi kontraktami projektu - drzewo kontrakt → kamienie → sprawy → zadania. Trafi do podfolderu „Spisy spraw\" w folderze projektu.",
                allPersonsLabel: "Wszystkich osób (cały projekt)",
                noOwnersNote: isLoadedProject
                    ? "W tym projekcie nie ma zadań przypisanych do konkretnych osób."
                    : "Lista osób jest dostępna dla projektu otwartego w drzewie zadań - kliknij projekt, żeby wybrać konkretne osoby.",
                noSelfTasksNote: "Nie masz zadań w tym projekcie - spis pokaże tylko zadania nieprzypisane.",
                taskOwners,
            } })));
}
